import React from 'react';
import { AlertCircle } from 'lucide-react';
import FeeTableRow from './FeeTableRow';

const FeeTable = ({
  students = [],
  fees = [],
  feeByStudentId = null,
  loading = false,
  selectedStudentIds = [],
  onToggleSelect,
  onToggleSelectAll,
  onAlertParent,
  onCollectPayment,
  onEditFee,
  onViewHistory,
  onViewStudentDrawer,
  onGenerateClearanceCert
}) => {
  const isAllSelected = students.length > 0 && selectedStudentIds.length === students.length;

  return (
    <div
      style={{
        background: '#ffffff',
        borderRadius: '8px',
        border: '1px solid #e2e8f0',
        overflowX: 'auto',
        WebkitOverflowScrolling: 'touch',
        boxShadow: '0 1px 3px rgba(0,0,0,0.03)',
        maxHeight: 'calc(100vh - 280px)',
        minHeight: '260px'
      }}
    >
      <table
        className="table table-hover align-middle mb-0"
        style={{
          margin: 0,
          minWidth: '1050px',
          fontSize: '12.5px',
          borderCollapse: 'separate',
          borderSpacing: 0
        }}
      >
        <thead style={{ position: 'sticky', top: 0, zIndex: 10 }}>
          <tr style={{ background: '#f8fafc', borderBottom: '1.5px solid #cbd5e1' }}>
            {/* 1. Master Select All Checkbox */}
            <th
              style={{
                padding: '8px 8px',
                textAlign: 'center',
                background: '#f8fafc',
                borderBottom: '1.5px solid #cbd5e1',
                width: '38px'
              }}
            >
              <input
                type="checkbox"
                checked={isAllSelected}
                onChange={onToggleSelectAll}
                style={{ cursor: 'pointer', width: '14px', height: '14px', borderRadius: '3px' }}
                title="Select / Deselect all students on current page"
              />
            </th>

            {/* 2. Student */}
            <th
              style={{
                padding: '8px 10px',
                color: '#475569',
                fontSize: '11px',
                fontWeight: '700',
                textTransform: 'uppercase',
                letterSpacing: '0.4px',
                background: '#f8fafc',
                borderBottom: '1.5px solid #cbd5e1',
                minWidth: '180px'
              }}
            >
              Student
            </th>

            {/* 3. Class / Section */}
            <th
              style={{
                padding: '8px 10px',
                color: '#475569',
                fontSize: '11px',
                fontWeight: '700',
                textTransform: 'uppercase',
                letterSpacing: '0.4px',
                background: '#f8fafc',
                borderBottom: '1.5px solid #cbd5e1',
                minWidth: '100px'
              }}
            >
              Class / Sec
            </th>

            {/* 4. Assigned Structure */}
            <th
              style={{
                padding: '8px 10px',
                color: '#475569',
                fontSize: '11px',
                fontWeight: '700',
                textTransform: 'uppercase',
                letterSpacing: '0.4px',
                background: '#f8fafc',
                borderBottom: '1.5px solid #cbd5e1',
                minWidth: '130px'
              }}
            >
              Structure Template
            </th>

            {/* 5. Total Fee */}
            <th
              style={{
                padding: '8px 10px',
                color: '#475569',
                fontSize: '11px',
                fontWeight: '700',
                textTransform: 'uppercase',
                letterSpacing: '0.4px',
                textAlign: 'right',
                background: '#f8fafc',
                borderBottom: '1.5px solid #cbd5e1',
                minWidth: '95px'
              }}
            >
              Total Fee
            </th>

            {/* 6. Paid */}
            <th
              style={{
                padding: '8px 10px',
                color: '#475569',
                fontSize: '11px',
                fontWeight: '700',
                textTransform: 'uppercase',
                letterSpacing: '0.4px',
                textAlign: 'right',
                background: '#f8fafc',
                borderBottom: '1.5px solid #cbd5e1',
                minWidth: '90px'
              }}
            >
              Paid
            </th>

            {/* 7. Outstanding */}
            <th
              style={{
                padding: '8px 10px',
                color: '#475569',
                fontSize: '11px',
                fontWeight: '700',
                textTransform: 'uppercase',
                letterSpacing: '0.4px',
                textAlign: 'right',
                background: '#f8fafc',
                borderBottom: '1.5px solid #cbd5e1',
                minWidth: '95px'
              }}
            >
              Outstanding
            </th>

            {/* 8. Status */}
            <th
              style={{
                padding: '8px 10px',
                color: '#475569',
                fontSize: '11px',
                fontWeight: '700',
                textTransform: 'uppercase',
                letterSpacing: '0.4px',
                textAlign: 'center',
                background: '#f8fafc',
                borderBottom: '1.5px solid #cbd5e1',
                minWidth: '90px'
              }}
            >
              Status
            </th>

            {/* 9. History */}
            <th
              style={{
                padding: '8px 10px',
                color: '#475569',
                fontSize: '11px',
                fontWeight: '700',
                textTransform: 'uppercase',
                letterSpacing: '0.4px',
                textAlign: 'center',
                background: '#f8fafc',
                borderBottom: '1.5px solid #cbd5e1',
                minWidth: '95px'
              }}
            >
              History
            </th>

            {/* 10. Actions */}
            <th
              style={{
                padding: '8px 10px',
                color: '#475569',
                fontSize: '11px',
                fontWeight: '700',
                textTransform: 'uppercase',
                letterSpacing: '0.4px',
                textAlign: 'center',
                background: '#f8fafc',
                borderBottom: '1.5px solid #cbd5e1',
                minWidth: '150px'
              }}
            >
              Actions
            </th>
          </tr>
        </thead>

        <tbody>
          {loading ? (
            <tr>
              <td colSpan={10} style={{ textAlign: 'center', padding: '48px 20px', color: '#64748b' }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
                  <div className="spinner-border text-primary" role="status" style={{ width: '2rem', height: '2rem' }}>
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <div style={{ fontWeight: '600', fontSize: '14px', color: '#334155' }}>
                    Loading student fee records...
                  </div>
                  <div style={{ fontSize: '12px', color: '#94a3b8' }}>
                    Fetching school roster and fee ledger accounts
                  </div>
                </div>
              </td>
            </tr>
          ) : students.length === 0 ? (
            <tr>
              <td colSpan={10} style={{ textAlign: 'center', padding: '40px 20px', color: '#64748b' }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
                  <AlertCircle size={32} color="#94a3b8" />
                  <div style={{ fontWeight: '600', fontSize: '14px', color: '#334155' }}>
                    No student fee records found
                  </div>
                  <div style={{ fontSize: '12px', color: '#94a3b8' }}>
                    Try changing your search query or reset the active filters.
                  </div>
                </div>
              </td>
            </tr>
          ) : (
            students.map((student) => {
              const fee = feeByStudentId ? feeByStudentId.get(String(student.studentId)) : fees.find((f) => f.studentId === student.studentId);
              const isSelected = selectedStudentIds.includes(student.studentId);

              return (
                <FeeTableRow
                  key={student.studentId}
                  student={student}
                  fee={fee}
                  isSelected={isSelected}
                  onToggleSelect={onToggleSelect}
                  onAlertParent={onAlertParent}
                  onCollectPayment={onCollectPayment}
                  onEditFee={onEditFee}
                  onViewHistory={onViewHistory}
                  onViewStudentDrawer={onViewStudentDrawer}
                  onGenerateClearanceCert={onGenerateClearanceCert}
                />
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
};

export default FeeTable;
